import React from 'react';
import { connect } from 'react-redux';

import Image from 'components/atoms/Image';
import { RootState } from 'types';
import { translate } from 'utils/translate';

interface ApplicationLoadingProps {
    applicationLoading: boolean;
}

interface ApplicationLoadingState {
    applicationLoading: boolean;
}

class ApplicationLoading extends React.Component<ApplicationLoadingProps, ApplicationLoadingState> {
    constructor(props: ApplicationLoadingProps) {
        super(props);
        this.state = {
            applicationLoading: false,
        };
    }

    static getDerivedStateFromProps(props: ApplicationLoadingProps, state: ApplicationLoadingState) {
        if (props.applicationLoading !== state.applicationLoading) {
            return {
                applicationLoading: props.applicationLoading,
            };
        }
        return null;
    }

    render() {
        return (
            <>
                {this.state.applicationLoading && (
                    <section className="z-100 fixed left-0 top-0 items-center justify-center inset-0 flex fixed-position w-full h-full   bg-white overflow-hidden">
                        <div className="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="relative">
                                <Image
                                    src="/static/images/logo.svg"
                                    style={{ width: 300 }}
                                    className="mx-auto "
                                    alt="logo"
                                />

                                <blockquote className="mt-2">
                                    <div className="flex items-center justify-center text-sm text-gray-900 leading-9">
                                        <Image src="/static/images/loading.svg" className="w-6 mr-2" alt="loading" />
                                        {translate('Loading, Please Wait...')}
                                    </div>
                                </blockquote>
                            </div>
                        </div>
                    </section>
                )}
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    applicationLoading: state.errors.applicationLoading,
});
export default connect(mapStateToProps)(ApplicationLoading);
